import { type RequestPayload, router } from "@inertiajs/core";
import { YearContextForm } from "../../components/yearContext/YearContextForm";
import { useYearContext } from "../../hooks/useYearContext";
import { ContentShell } from "../../layout/ContentShell";
import { year_contexts_path } from "../../routes";

export default function YearContextCreate() {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.post(pathWithYearContext(year_contexts_path), values);
  return (
    <ContentShell title="Neuer Jahrgang" onBack={() => router.get(pathWithYearContext(year_contexts_path))}>
      <YearContextForm submitButtonLabel="Erstellen" onSubmit={onSubmit} />
    </ContentShell>
  );
}
